import { Routes, Route } from "react-router-dom";
import { AdminAuthProvider } from "../../lib/admin";
import { AdminLogin, AdminReset } from "./AdminAuth";
import AdminDashboard from "./AdminDashboard";

export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <div data-lenis-prevent>
        <Routes>
          <Route path="login" element={<AdminLogin />} />
          <Route path="reset" element={<AdminReset />} />
          <Route path="*" element={<AdminDashboard />} />
        </Routes>
      </div>
    </AdminAuthProvider>
  );
}
